(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vnf-shipping-floating"]) return;
  try {
    
  if (!customElements.get('vnf-shipping-floating')) {
    customElements.define('vnf-shipping-floating', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        try { this.dismissed = sessionStorage.getItem('vnf-shipping-dismissed') === 'true'; } catch {}
        this.hidden = this.dismissed || !this.querySelector('[data-vnf-shipping-progress]');
        this.closeTracker = () => {
          this.dismissed = true;
          this.hidden = true;
          clearTimeout(this.timer);
          this.controller?.abort();
          try { sessionStorage.setItem('vnf-shipping-dismissed', 'true'); } catch {}
        };
        this.querySelector('.vnf-floating__close').addEventListener('click', this.closeTracker);
        this.refresh = () => {
          if (this.dismissed) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.update(), 150);
        };
        document.addEventListener('cart:update', this.refresh);
        document.addEventListener('discount:update', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        document.removeEventListener('cart:update', this.refresh);
        document.removeEventListener('discount:update', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
        this.querySelector('.vnf-floating__close').removeEventListener('click', this.closeTracker);
        this.initialized = false;
      }
      async update() {
        if (this.dismissed) return;
        this.controller?.abort();
        this.controller = new AbortController();
        try {
          const url = new URL(this.dataset.root, window.location.origin);
          url.searchParams.set('sections', this.dataset.sectionId);
          const response = await fetch(url, {signal:this.controller.signal, cache:'no-store'});
          if (!response.ok) return;
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (!html) return;
          const page = new DOMParser().parseFromString(html, 'text/html');
          const content = page.querySelector('[data-floating-content]');
          if (!content) return;
          this.querySelector('[data-floating-content]').replaceChildren(...content.childNodes);
          this.hidden = this.dismissed || !this.querySelector('[data-vnf-shipping-progress]');
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
